module.exports = {"projects":[[0,"BeHive"],[1,"Gravity"],[2,"Maestro"],[3,"T1000"],[4,"ACME"]],"categories":[[0,"UI"],[1,"Suivi de demande"],[2,"Points de montage"],[3,"Commercial"],[4,"Demandes de fonctionalité"],[5,"Catalogue"],[6,"Sujet libre"],[7,"Demandes de fonctionalité"],[8,"Gestion client"]]}


//////////////////
// WEBPACK FOOTER
// ./src/support.json
// module id = kiL8
// module chunks = 55